import AjaxUtil from '../../axios/axios';

/**
 * 
 * @param {*} data 
 * @returns 
 */
export const getDeepSearchReport = async(topicId, ai_module_id) => {
    try {
        return await AjaxUtil.sendRequest(`/start-deep-search?topic_id=${topicId}&ai_module_id=${ai_module_id}`, {}, false, { method: 'post', showError: true, isRagUrl : true} );
    } catch (error) {
        throw error;
    }
}

/**
 * 
 * @param {*} data 
 * @returns 
 */
export const getReportData = async(topicId) => {
    try {
        return await AjaxUtil.sendRequest(`getdeepsearch/${topicId}`, {}, false, { method: 'get', showError: true } );
    } catch (error) {
        throw error;
    }
}